import { useQuery } from '@tanstack/react-query'
import { chatService } from '../services/chatService'
import { useChatPanel } from '../contexts/ChatPanelContext'
import './ChatNotificationBadge.css'

export function ChatNotificationBadge() {
  const { isOpen } = useChatPanel()

  const { data: unreadCount = 0 } = useQuery({
    queryKey: ['chat-unread-count'],
    queryFn: chatService.getUnreadCount,
    refetchInterval: 30000, // Poll every 30 seconds for unread count
    enabled: !isOpen, // Only poll when panel is closed
  })

  if (unreadCount === 0 || isOpen) return null

  return (
    <span className="chat-notification-badge" aria-label={`${unreadCount} unread messages`}>
      {unreadCount > 99 ? '99+' : unreadCount}
    </span>
  )
}
































